import { useEffect } from "react";

import { getSmarticoRaffles, setRaffleId } from "../store";
import { useAppDispatch } from "../../../hooks";
import { ITombolaPageProps } from "../interfaces/ITombolaPageProps";
import useSmartico from "../../../../hooks/useSmartico";

export const TombolaPage = ({ isAuth, searchParamRaffleId, Render }: ITombolaPageProps) => {
  const dispatch = useAppDispatch();
  let raffleId = searchParamRaffleId;
  const api = useSmartico();

  useEffect(() => {
    dispatch(setRaffleId(raffleId));
    dispatch(getSmarticoRaffles(api));
  }, []);

  return <Render />;
};
